// extracted by mini-css-extract-plugin
export default {"op":"PieSlice_op__VyezV","slice":"PieSlice_slice__1Xjcj","label":"PieSlice_label__ph4N9"};